import {
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  DELETE,
} from 'react-admin';
import queryString from 'query-string';
import { getApiUrlForResource } from '../services/apiUrlResolver';
import { PARTNER_MARKETING_ASSETS_RESOURCE_NAME, partnerMarketingAssetsFields } from './partnerMarketingAssets.model';

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource(PARTNER_MARKETING_ASSETS_RESOURCE_NAME);

const providerRequestToHttpRequest = (requestType: string, requestParams: any) => {
  switch (requestType) {
    case GET_LIST:
      return composeGetListRequest(requestParams);
    case GET_ONE:
      return { url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}/${requestParams.id}` };
    case CREATE:
      return {
        url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}`,
        options: { method: 'POST', body: JSON.stringify(requestParams.data) },
      };
    case UPDATE:
      return {
        url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}/${requestParams.id}`,
        options: { method: 'PUT', body: JSON.stringify(requestParams.data) },
      };
    case DELETE:
      return {
        url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}/${requestParams.id}`,
        options: { method: 'DELETE' },
      };
    case 'GET_PRESIGNED_URL':
      return {
        url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}/presigned-url`,
        options: {
          method: 'POST',
          body: JSON.stringify(requestParams),
        },
      };
    case 'GET_FOLDERS':
      return {
        url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}/folders`,
      };
    case 'REPLACE_ASSET':
      return {
        url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}/${requestParams.id}/replace`,
        options: {
          method: 'POST',
          body: JSON.stringify(requestParams.data),
        },
      };
    default:
      throw new Error(`Unsupported fetch action type ${requestType}`);
  }
};

const httpResponseToProviderData = (httpResponse: any, requestType: string, requestParams: any) => {
  const { json } = httpResponse;

  switch (requestType) {
    case GET_LIST:
      return {
        data: json.data || [],
        total: json.total || 0,
      };
    case GET_ONE:
      return { data: json };
    case CREATE:
      // Merge full server response to preserve all server-generated fields
      // (id, public_url, s3_key, created_at, updated_at, etc.)
      return { data: { ...requestParams.data, ...json } };
    case UPDATE:
      return { data: json };
    case DELETE:
      return { data: { id: requestParams.id } };
    case 'GET_PRESIGNED_URL':
      return { data: json };
    case 'GET_FOLDERS':
      return { data: json.folders || [] };
    case 'REPLACE_ASSET':
      return { data: json };
    default:
      return { data: json };
  }
};

const composeGetListRequest = (requestParams: any) => {
  const { page, perPage } = requestParams.pagination;
  const { field, order } = requestParams.sort;
  const filter = requestParams.filter || {};

  const queryParams: any = {
    page,
    per_page: perPage,
    sort_by: field,
    sort_order: order.toLowerCase(),
  };

  // Add filters
  if (filter[partnerMarketingAssetsFields.folderPath] !== undefined) {
    queryParams.folder_path = filter[partnerMarketingAssetsFields.folderPath];
  }
  if (filter[partnerMarketingAssetsFields.fileType]) {
    queryParams.file_type = filter[partnerMarketingAssetsFields.fileType];
  }
  if (filter.search || filter.q) {
    queryParams.search = filter.search || filter.q;
  }

  return { url: `${getApiUrl()}/${PARTNER_MARKETING_ASSETS_RESOURCE_NAME}?${queryString.stringify(queryParams)}` };
};

export { PARTNER_MARKETING_ASSETS_RESOURCE_NAME };

export default {
  resource: PARTNER_MARKETING_ASSETS_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest,
    httpResponseToProviderData,
  },
};
